module.exports = "/images/trialproofer-emblem.svg?bad263ae09be3b1e93a1c1588a9417ad";